export default __webpack_public_path__ + "static/1.2_IT-696cf1f8cc17e3f9ecdb92d846c9760e.webp";